const mapping = {
  update_project: 'home/updateProject',
  update_unit: 'home/updateUnit',
  update_notification: 'home/addNotifications',
  update_statistics: 'home/updateStats',
  bid_won_lost: 'home/showWonLostBid',
  update_bid: 'home/updateBid',
  update_locality: 'home/updateLocality',
  update_internal_master: 'master/updateInternalMaster',
  update_auctioneer_live: 'auctioneer/updateAuctioneerLive',
  update_rm_live: 'rm/updateRmLive',
  update_rm_customer: 'rm/updateRmCustomer',
  update_rm_projects: 'rm/updateRmProject',
  update_broker_list: 'rm/updateRmBroker',
  update_favourite: 'auth/updateFav',
  update_favourite_unit: 'home/updateFavUnitSignal',
  remove_sold_unit: 'home/removeSoldUnit',
};

export default mapping;



// WEBPACK FOOTER //
// ./src/constants/socketActionMapping.js